module.exports = __webpack_public_path__ + "static/images/smoothness/ui-bg_glass_95_fef1ec_1x400.png";